import React from 'react';
type SectionLabelProps = {
  children: React.ReactNode;
  tone?: 'accent' | 'danger';
};
export function SectionLabel({
  children,
  tone = 'accent'
}: SectionLabelProps) {
  const styles = tone === 'danger' ? 'border-danger/30 bg-danger/10 text-danger' : 'border-accent/30 bg-accent/10 text-accent';
  return <span className={`inline-block rounded-md border px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.2em] sm:text-[11px] ${styles}`} data-id="element-66" data-mp="33ep6t4q8wy22">
      {children}
    </span>;
}